import { ICommand } from 'core-ts-types';
import * as _4 from 'lodash4';
import { CommunicatorService } from 'ui-ng-component-communicator';
import { INotificationDelegate } from '../../../global/helpers/notification_delegate';
import { APCourse } from '../../builders/ap_course_builder';
import { APGenericSlot, CourseGroupSlot, CourseSlot, WildcardSlot } from '../../builders/ap_generic_slot_builder';

class CourseGroupButtonController {
  private courseSlot: CourseSlot;
  private buttonType: string;
  private buttonLabel: string;
  private parentCourse: CourseGroupSlot | WildcardSlot;
  private hasPlannedCourse: boolean;
  private isCourseGroupPlanned: boolean;
  private term: string;
  private showButton: boolean;
  private planningNotificationName: string = 'planningCourse';

  constructor(
    private removeCourseGroupFromTermCommand: ICommand,
    private saveCourseGroupToTermCommand: ICommand,
    private saveCourseToTermCommand: ICommand,
    private removeCourseGroupFromTermAndAddCourseCommand: ICommand,
    private removeCourseFromTermAndAddCourseGroupCommand: ICommand,
    private removeCourseFromTermAndAddCourseCommand: ICommand,
    private ngComponentCommunicatorService: CommunicatorService,
    private phxAxTitleAnnouncerDelegate: any,
    private ngAPNotificationDelegate: INotificationDelegate
  ) {}

  initialize() {
    this.hasPlannedCourse = _4.has(this.parentCourse, 'plannedCourse.id');
    this.isCourseGroupPlanned = _4.has(this.parentCourse.plannedCourseGroup, 'id');
    this.buttonType = 'add';
    this.buttonLabel = this._getButton().buttonLabel;
    this.showButton =
      !this.courseSlot.isPlannedSomewhere ||
      (this.courseSlot.isPlannedSomewhere && !!this.courseSlot.isPlannedInCurrentGroup);
  }

  $onInit() {
    this.initialize();
  }

  $onChanges() {
    this.initialize();
  }

  courseActionButton(e: Event) {
    if (this.buttonType === 'swap') {
      e.stopPropagation();
      this.swapCourse();
    } else if (this.buttonType === 'remove') {
      this.removeCourse();
    } else if (this.buttonType === 'add') {
      this.addCourse();
    }
  }

  showNotification(content: string) {
    this.ngAPNotificationDelegate.info({
      content: `<div l-kind="hort" l-align="center" l-width-fixed><hi-indicator theme="white" size='small' class="mrm"></hi-indicator>${content} </div>`,
      name: this.planningNotificationName
    });
  }

  hideNotification() {
    this.ngAPNotificationDelegate.dismissAlertByName(this.planningNotificationName);
  }

  addCourse() {
    if (this.parentCourse.programSlot) {
      this.showNotification(`Planning the course: ${this.courseSlot.course._title}`);
      this.removeCourseGroupFromTermAndAddCourseCommand(
        this.parentCourse.programSlot,
        this.parentCourse.programSlot._course_group,
        this.courseSlot.course
      ).then(() => this.coursePlanned());
    }
  }

  coursePlanned() {
    this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
    this.phxAxTitleAnnouncerDelegate.announceChange(`${this.courseSlot.course.title} was planned in ${this.term}`);
    this.hideNotification();
  }

  saveCourse() {
    this.showNotification(`Planning the course: ${this.courseSlot.course._title}`);
    this.saveCourseToTermCommand(
      this.courseSlot.course.id,
      this.parentCourse.termId,
      this.parentCourse.programSlot,
      !!this.parentCourse.programSlot.is_devreq
    ).then(() => this.coursePlanned());
  }

  swapCourse() {
    if (!this.parentCourse.plannedCourse) {
      return;
    }
    this.showNotification(`Swapping the course: ${this.courseSlot.course._title}`);

    this.removeCourseFromTermAndAddCourseCommand(
      this.parentCourse.plannedCourse,
      this.courseSlot.course,
      this.parentCourse.programSlot,
      this.parentCourse.plannedCourse.term,
      this.parentCourse.plannedCourse.term
    ).then(() => {
      this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
      this.phxAxTitleAnnouncerDelegate.announceChange(
        `${_4.get(this.parentCourse, 'plannedCourse._course._title', '')} was swapped with ${_4.get(
          this.courseSlot,
          'course._title',
          ''
        )} in ${this.term}`
      );
      this.hideNotification();
    });
  }

  removeCourse() {
    this.showNotification(`Un-planning the course: ${_4.get(this.parentCourse, 'plannedCourse._course._title', '')}`);
    this.removeCourseFromTermAndAddCourseGroupCommand(
      this.parentCourse.plannedCourse,
      this.parentCourse.termId,
      this.parentCourse.programSlot
    ).then(() => {
      this.ngComponentCommunicatorService.publish('CLOSE_LARGE_COURSE_GROUP_PANEL');
      this.phxAxTitleAnnouncerDelegate.announceChange(
        `${_4.get(this.parentCourse, 'plannedCourse._course._title')} removed from ${this.term}`
      );
      this.hideNotification();
    });
  }

  _getButton() {
    const removeString = 'Un-plan';
    const addString = 'Plan';
    const swapString = 'Swap';
    const isCurrentCoursePlanned: boolean =
      !!this.parentCourse.plannedCourse && this.parentCourse.plannedCourse.course === this.courseSlot.course.id;
    let buttonLabel: string = addString;

    if (isCurrentCoursePlanned && this.hasPlannedCourse) {
      buttonLabel = removeString;
      this.buttonType = 'remove';
    } else if (!isCurrentCoursePlanned && this.hasPlannedCourse) {
      buttonLabel = swapString;
      this.buttonType = 'swap';
    }
    return {
      buttonLabel,
      buttonType: this.buttonType
    };
  }
}

class CourseGroupButton implements ng.IComponentOptions {
  public bindings: any;
  public controller: any;
  public templateUrl: any;

  constructor() {
    this.bindings = {
      courseSlot: '<',
      parentCourse: '<',
      term: '<'
    };
    this.controller = CourseGroupButtonController;
    this.templateUrl =
      'capability-ng-academic-planner/src/global/components/course_group_button/course_group_button.html';
  }
}

angular.module('capability-ng-academic-planner').component('courseGroupButton', new CourseGroupButton());



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-academic-planner/src/global/components/course_group_button/course_group_button.ts